// 画像アップロード用のカスタムフック
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ImageService } from '../services/imageService';

export const useImageUpload = () => {
  const { currentUser } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const sanitizeFileSegment = (value: string): string =>
    value.replace(/[^a-zA-Z0-9_-]+/g, '_').replace(/^_+|_+$/g, '') || 'image';

  const uploadImage = async (
    file: File,
    siteId: string,
    slotId: string,
    options?: { useUniqueName?: boolean }
  ): Promise<string> => {
    try {
      setUploading(true);
      setUploadProgress(0);

      // 認証チェック
      if (!currentUser) {
        throw new Error('ログインが必要です');
      }

      // ファイル拡張子を決定
      let fileExtension: string;
      if (file.type === 'image/gif') {
        fileExtension = 'gif';
      } else {
        fileExtension = 'webp';
      }
      
      const originalName = file.name.replace(/\.[^/.]+$/, '');
      const baseFileName = sanitizeFileSegment(originalName);
      const originalFileName = `${baseFileName}.${fileExtension}`;
      const fileName = options?.useUniqueName
        ? `${baseFileName}_${sanitizeFileSegment(slotId)}_${Date.now()}.${fileExtension}`
        : originalFileName;

      const downloadURL = await ImageService.uploadMedia(file, siteId, undefined, {
        fileName,
        overwrite: false,
        autoNumber: false,
        skipExistsCheck: options?.useUniqueName === true,
      });
      
      setUploadProgress(100);
      return downloadURL;
    } catch (error) {
      console.error('画像アップロードに失敗しました:', error);
      throw error;
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  const deleteImage = async (imageUrl: string): Promise<void> => {
    try {
      await ImageService.deleteImage(imageUrl);
    } catch (error) {
      console.error('画像削除に失敗しました:', error);
      throw error;
    }
  };

  return {
    uploadImage,
    deleteImage,
    uploading,
    uploadProgress,
  };
};